<template>
    <div class="service-item-portrait round-corner" @click="service ? serviceJump(service) : locationTo(linkUrl)">
        <div class="service-icon-box">
            <img class="service-icon" onload="SVGInject(this)" :src="complete(imgUrl)" />
        </div>
        <div class="service-name">{{ service.name }}</div>
    </div>
</template>

<script>
    import { serviceJump } from "@/utils/serviceUtil"
    import { complete, locationTo } from "@/utils/url"
    import * as svg from "@/utils/svg-inject.min"

    export default {
        name: "ServiceItemPortraitOne",
        components: {},
        props: ["service", "linkUrl"],
        data() {
            return {
                imgUrl: this.service.icon,
            }
        },
        computed: {},
        methods: {
            complete,
            serviceJump,
            locationTo,
        },
        mounted() {
        },
    }
</script>

<style scoped lang="scss">
    @import "~@/assets/css/theme/theme.scss";
    .service-item-portrait {
        // display: flex;
        // width: 70px;
        // flex-direction: column;
        // align-content: center;
        // align-items: center;
        // justify-content: center;
        // padding: 24px 6px 0;

        width: 100%;
        //height: 85px;
        padding: 7px 0;
        box-sizing: border-box;
        text-align: center;
    }
    .service-icon-box {
        height: 40px;
        svg {
            fill: var(--main-color);
        }
    }
    .service-icon {
        width: 24px;
        height: 24px;
    }
    .service-name {
        width: 17vw;
        //height: 22px;
        line-height: 20px;
        text-align: center;
        //white-space: nowrap;
        //overflow: hidden;
        //text-overflow: ellipsis;
        white-space: normal !important;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        @extend .font13;
    }
</style>
